import { Module, Role } from "@/constants";

import { MenuItem } from "@/types";

export const menuItems: MenuItem[] = [
  { path: "/homepage", label: "Homepage" },
  { path: "/dashboard", label: "Support Endpoints" },
  { path: "/support-ai", label: "Support AI" },
  { path: "/restores", label: "Restores" },
  { path: "/eliza-billing", label: "Eliza Billing" },
  { path: "/billing", label: "Billing" },
  { path: "/stripe", label: "Stripe" },
  { path: "/identity-platform", label: "Identity Platform" },
  {
    path: "/support-affiliate-portal",
    label: "Affiliate Portal",
    module: Module.AFFILIATE,
    role: Role.L1,
  },
  {
    path: "/support-health-check-portal",
    label: "Health Check Portal",
  },
  { path: "/company", label: "Company" },
  { path: "/blacklists", label: "Blacklists" },
  { path: "/sub-accounts", label: "Sub Accounts" },
  { path: "/saas", label: "SaaS Mode" },
  {
    path: "/marketplace-apps-review",
    label: "Marketplace Review Dashboard",
  },
  {
    path: "/kollab-support",
    label: "Kollab Support",
    module: Module.KOLLAB_SUPPORT,
    role: Role.L1,
  },
  { path: "/marketplace-app-management", label: "Marketplace App Management" },
  {
    path: "/marketplace-developers",
    label: "Marketplace Developers",
    module: Module.MARKETPLACE_APP_SUPPORT,
    role: Role.L1,
  },
  { path: "/funnels", label: "Funnels" },
  { path: "/forms-surveys", label: "Forms & Surveys" },
  { path: "/email-isv", label: "LC Email" },
  { path: "/lc-domain", label: "LC Domain" },
  { path: "/client-portal-settings", label: "Client Portal Settings" },
  { path: "/isv", label: "ISV" },
  { path: "/yext", label: "Yext" },
  { path: "/wordpress", label: "WordPress" },
  { path: "/whatsapp", label: "WhatsApp" },
  { path: "/feature-feedbacks", label: "Feature Feedbacks" },
  { path: "/labs", label: "Labs" },
  { path: "/reputation", label: "Reputation" },
  { path: "/reselling", label: "Reselling" },
  { path: "/medias", label: "Medias" },
  { path: "/onboarding", label: "Onboarding" },
  { path: "/launchpad", label: "Launchpad" },
  { path: "/wallet", label: "Wallet" },
  {
    path: "/custom-offers",
    label: "Custom Offers",
    module: Module.CUSTOM_OFFERS,
    role: Role.L1,
  },
  { path: "/legal", label: "Legal", module: Module.LEGAL, role: Role.L1 },
  {
    path: "/premium-support",
    label: "Premium Support",
    module: Module.PREMIUM_SUPPORT,
  },

  { path: "/ai-employee", label: "AI Employee", module: Module.AI_WRAPPER },
  { path: "/logs", label: "Logs" },
  { path: "/tourguide", label: "Tour Guide" },
  { path: "/recordings", label: "Recordings" },
];
